<template>
  <navigation-menu-item target-path="balance" title="מצב העו״ש והאשראי"
                        v-on:navigate="$emit('navigate')"
                        :disabled="!allowNavigationToBalancePage" />
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import { SUBSCRIPTION_STATES } from '@/constants/subscription-state';
import NavigationMenuItem from './NavigationMenuItem.vue';

export default {
  name: 'BalancePageMenuItem',
  components: { NavigationMenuItem },
  async created() {
    await this.fetchCredentials();
  },
  computed: {
    ...mapState('credentials', ['credentialsList']),
    ...mapState('subscriptionState', ['subscriptionState']),
    ...mapState('applicationState', ['cashflowState']),
    ...mapGetters('applicationState', ['cashflowTypes']),
    allowNavigationToBalancePage() {
      return !this.hasDiscountApiAccount
        && !this.isDormant
        && !this.isPreTrial
        && !this.cashflowOutOfDate
        && !this.cashflowBlocked;
    },
    hasDiscountApiAccount() {
      return _.some(this.credentialsList, credentials => credentials.sourceName === 'דיסקונט ישיר');
    },
    isDormant() {
      return [SUBSCRIPTION_STATES.DORMANT_AFTER_CANCELED, SUBSCRIPTION_STATES.DORMANT_AFTER_TRIAL].includes(this.subscriptionState);
    },
    isPreTrial() {
      return SUBSCRIPTION_STATES.PRE_TRIAL === this.subscriptionState;
    },
    cashflowOutOfDate() {
      return this.cashflowState === this.cashflowTypes.OUT_OF_DATE;
    },
    cashflowBlocked() {
      return this.cashflowState === this.cashflowTypes.BLOCKED;
    },

  },
  methods: {
    ...mapActions('credentials', ['fetchCredentials']),
  },
};
</script>

<style scoped lang="scss">
  @import "~base-ui/src/scss/riseup-colors";

  .disabled {
    color: $riseup_gray_1;
    cursor: not-allowed;
  }
</style>
